// modules/shared/src/services/sentryAxiosFingerprint.js
// CommonJS so the webpack build imports it AND plain `node` can require() it
// for the standalone verify script (sentryAxiosFingerprint.verify.js).

const UUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
const NUMERIC_RE = /^\d+$/
const HEX24_RE = /^[0-9a-fA-F]{24}$/

function normalizeUrlPath(url) {
  if (!url) return 'unknown'
  let path
  try {
    // base lets relative urls parse; we keep only the pathname (drops query/hash)
    path = new URL(url, 'http://_').pathname
  } catch (e) {
    path = String(url).split('?')[0].split('#')[0]
  }
  const normalized = path
    .split('/')
    .map(seg => (UUID_RE.test(seg) || NUMERIC_RE.test(seg) || HEX24_RE.test(seg) ? '{id}' : seg))
    .join('/')
  return normalized || '/'
}

function axiosFingerprint(error) {
  if (!error || error.isAxiosError !== true) return null
  const config = error.config
  const response = error.response
  if (!config && !response) return null
  const method = (config && config.method ? String(config.method) : 'unknown').toUpperCase()
  const path = normalizeUrlPath(config && config.url)
  const status = response && response.status ? String(response.status) : 'no-response'
  return ['axios', method, path, status]
}

function axiosFingerprintProcessor(event, hint) {
  try {
    const fp = axiosFingerprint(hint && hint.originalException)
    if (fp) {
      event.fingerprint = fp
      event.tags = Object.assign({}, event.tags, {
        'axios.endpoint': `${fp[1]} ${fp[2]}`,
        'axios.status': fp[3],
      })
    }
  } catch (e) {
    // never let enrichment drop an event
  }
  return event
}

module.exports = { normalizeUrlPath, axiosFingerprint, axiosFingerprintProcessor }
